import { useState } from 'react';
import { mailAddressOk } from '@lemontaigu/platform';
import { PLATFORM_ENV } from './config.js';

// « E-mails » (Réception group — ADR-0027, RUNBOOK §25.2). The operator checks
// the platform's sending end to end: Brevo key in Cloudflare, sender, domain
// authentication. One address, one test mail, the answer on screen; then read
// the received mail's headers for SPF / DKIM « pass ». The send is handed in
// by main.tsx (the SPA entry) — this view names no infrastructure.

export function MailTest({ send: sendTest }: { send: (to: string) => Promise<{ ok: boolean; detail: string }> }) {
  const [to, setTo] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; detail: string } | null>(null);

  const send = async () => {
    setBusy(true);
    setResult(null);
    setResult(await sendTest(to.trim()));
    setBusy(false);
  };

  return (
    <div className="equipe hs-page">
      <div className="equipe-head">
        <h2 className="section-title">E-mails — test d’envoi</h2>
        <span className="equipe-hint">
          Les confirmations de réservation partent de reservations@lemontaigu.com par Brevo (réponses vers
          info@lemontaigu.com). Envoyez-vous un e-mail de test : il doit arriver dans la boîte de réception, pas
          dans les indésirables. Environnement : {PLATFORM_ENV}.
        </span>
      </div>
      <section className="hs-section">
        <form
          className="hs-form"
          onSubmit={(e) => {
            e.preventDefault();
            void send();
          }}
        >
          <label className="pms-field">
            <span>Adresse de test</span>
            <input type="email" inputMode="email" autoComplete="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="vous@gmail.com" />
          </label>
          <button type="submit" className="auth-btn" disabled={busy || !mailAddressOk(to)}>
            {busy ? 'Envoi…' : 'Envoyer un e-mail de test'}
          </button>
        </form>
        {result && <p className={result.ok ? 'emp-ok' : 'auth-err'}>{result.detail}</p>}
        <p className="equipe-hint">
          Dans l’e-mail reçu : Gmail › ⋮ › « Afficher l’original » ; Outlook › … › « Afficher la source ». Il faut
          SPF : PASS et DKIM : PASS pour lemontaigu.com. Testez une adresse Gmail et une adresse Outlook/Hotmail.
        </p>
      </section>
    </div>
  );
}
